import { ROSELoader } from './rose';
import { BinaryReader } from '../util/binaryreader';
import { BinaryWriter } from '../util/binarywriter';

/**
 * @property {Number} width
 * @property {Number} height
 * @property {Number} gridCount
 * @property {Number} patchSize
 * @property {Number[]} map
 */
export class HeightmapData {
  width: number = 0;
  height: number = 0;
  gridCount: number = 0;
  patchSize: number = 0;
  map: number[] = [];

  static parse(rh: BinaryReader): HeightmapData {
    const data = new HeightmapData();
    data.width     = rh.readUint32();
    data.height    = rh.readUint32();
    data.gridCount = rh.readUint32();
    data.patchSize = rh.readFloat();

    for (let i = 0; i < data.width * data.height; ++i) {
      data.map.push(rh.readFloat());
    }
    return data;
  }

  static serialize(data: HeightmapData): ArrayBuffer {
    const expected = data.width * data.height;
    if (data.width < 0 || data.height < 0 || data.map.length !== expected) {
      throw new Error(
        `Invalid HIM dimensions: ${data.width}x${data.height} requires ${expected} heights, got ${data.map.length}`,
      );
    }

    const writer = new BinaryWriter(16 + expected * 4);
    writer.writeUint32(data.width);
    writer.writeUint32(data.height);
    writer.writeUint32(data.gridCount);
    writer.writeFloat(data.patchSize);
    for (const height of data.map) writer.writeFloat(height);
    return writer.toArrayBuffer();
  }

  /**
   * @param {String} path
   * @param {Function} callback
   */
  static load(path: any, callback: any) {
    ROSELoader.load(path, function(rh: any) {
      callback(HeightmapData.parse(rh));
    });
  }
}
